import {Injectable} from '@angular/core';
import {IKeyedCollection, KeyedCollection} from '..';

@Injectable()
export class ExportService {

    public static QUESTION_PREFIX = 'Q: ';

    private static getFileExtension(fileName: string) {
        let regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        let extension = fileName.match(regexp);
        return extension && extension[1];
    }

    private static formatOuiNon(data?: any, record?: any): string {
        if (data != null) {
            if (data === true) {
                return 'Oui';
            }
            if (data === false) {
                return 'Non';
            }
            return data;
        }
        return '';
    }

    private static formatEI(data?: any, record?: any): string {
        if (data != null) {
            if (data === 0 || data === '0') {
                return 'Non concerné';
            }
            if (data === 1 || data === '1') {
                return 'En échange';
            }
            if (data === 2 || data === '2') {
                return 'Hors échange';
            }
            return data;
        }
        return '';
    }

    private static formatQuestionsComplementaires(data?: any, candidatureFormation?: any): string {
        let reponseString = '';
        if (candidatureFormation != null && candidatureFormation.reponses != null) {
            candidatureFormation.reponses.forEach(reponse => {
                reponseString.length == 0 ? reponseString +=
                    ExportService.buildReponseLibelle(reponse) : reponseString += '\n' + ExportService.buildReponseLibelle(reponse);
            });
        }
        return reponseString;
    }

    private static formatQuestionsComplementairesParColonne(question?: any, candidatureFormation?: any): string {
        let reponseString = '';
        if (candidatureFormation != null && candidatureFormation.reponses != null) {
            candidatureFormation.reponses.forEach(reponse => {
                if ((ExportService.QUESTION_PREFIX + reponse.question.libelle) === question && reponse.response != null) {
                    reponseString = reponse.response;
                }
            });
        }
        return reponseString;
    }

    private static formatRespoForma(data?: any, formation?: any): string {
        let reponseString = '';
        if (formation != null && formation.users != null) {
            formation.users.forEach(user => {
                reponseString.length == 0 ?
                    reponseString += ExportService.formatUser(user) :
                    reponseString += '\n' + ExportService.formatUser(user);
            });
        }
        return reponseString;
    }

    private static formatLecteurs(data?: any, formation?: any): string {
        let reponseString = '';
        if (formation != null && formation.lecteurs != null) {
            formation.lecteurs.forEach(lecteur => {
                reponseString.length == 0 ?
                    reponseString += ExportService.formatUser(lecteur) :
                    reponseString += '\n' + ExportService.formatUser(lecteur);
            });
        }
        return reponseString;
    }

    private static formatUser(user: any): string {
        return user.lastNameUsage + ' ' + user.firstName + ' (' + user.email + ')';
    }

    public static buildReponseLibelle(reponse): string {
        return ('[' + ExportService.textTruncate(reponse.question.libelle, 50) + '] ' + reponse.response)
            .replace(/<\/?[^>]+(>|$)/g, '').replace(':', '');
    }

    static textTruncate = function (str, length): string {
        if (length == null) {
            length = 100;
        }
        let ending = '...';

        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    private static formatRang(rang?: any, record?: any): string {
        let rangString = '';
        if (rang != undefined && record != null && record['lc'] != undefined && record['lc'] != null) {
            if (record['lc'] == true) {
                rangString = ExportService.formatOuiNon(rang, record);
            }
        }
        return rangString;
    }

    private static formatRangAuto(rangAuto?: any, record?: any): string {
        let rangString = '';
        if (rangAuto != undefined && record != null && record['lc'] != undefined
            && record['lc'] != null && record['rang'] != undefined && record['rang'] != null) {
            if (record['lc'] == true && record['rang'] == true  ) {
                rangString = ExportService.formatOuiNon(rangAuto, record);
            }
        }
        return rangString;
    }

    private static formatFC(data?: any, record?: any): string {
        if (data != null) {
            if (data === true) {
                return 'Oui';
            } else {
                return 'Non';
            }
        }
        return '';
    }

    private static formatStatut(data?: any, record?: any): string {
        if (data != null) {
            if (record != null && record['dateSuppression'] != null) {
                return 'Supprimé';
            }
            if (data === 'FINISHED') {
                return 'Transmis';
            }
            if (data === 'CREATED') {
                return 'En cours';
            }
            if (data === 'FAVORABLE') {
                return 'Favorable';
            }
            if (data === 'NOTFAVORABLE') {
                return 'Défavorable';
            }
            if (data === 'SUCCESS') {
                return 'Admis';
            }
            if (data === 'DESISTED') {
                return 'Désistement';
            }
            return data;
        }
        return '';
    }


    private static formatData(data?: any, record?: any): string {
        if (data != null) {
            if (data === true) {
                return 'Oui';
            }
            if (data === false) {
                return 'Non';
            }
            if (data === 'FINISHED') {
                return 'Transmis';
            }
            if (data === 'CREATED') {
                return 'En cours';
            }
            if (data === 'FAVORABLE') {
                return 'Favorable';
            }
            if (data === 'NOTFAVORABLE') {
                return 'Défavorable';
            }
            if (data === 'SUCCESS') {
                return 'Admis';
            }

            /* if (data === 'REJECTED') { return 'Admis'; }
            if (data === 'DESISTED') { return 'Admis'; }
            //if (data === 'AWAITING') { return 'Admis'; }
            if (data === 'AWAITING') { return 'Admis en LC'; }
            if (data === 'CONFIRMED') { return 'Admis'; }
            if (data === 'NOTCONFORME') { return 'Admis'; }
            if (data === 'CONFORME') { return 'Admis'; }*/

            if (data === 'REJECTED') {
                return 'Refusé';
            }
            if (data === 'DESISTED') {
                return 'Désistement confirmé';
            }
            // if (data === 'AWAITING') { return 'Admis'; }
            if (data === 'AWAITING') {
                return 'Admis en LC';
            }
            if (data === 'CONFIRMED') {
                return 'Venue confirmée';
            }
            if (data === 'NOTCONFORME') {
                return 'Non conforme';
            }
            if (data === 'CONFORME') {
                return 'Conforme';
            }

            if (data === 'MASTER') {
                return 'Master';
            }
            if (data === 'DIPLOME') {
                return 'Diplôme de l\'ENS';
            }
            if (data === 'AUTRES') {
                return 'Autres';
            }
            if (data === 'fc') {
                return 'Formation continue';
            }

            if (typeof data === 'string') {
                data = data.replace('REJECTED', 'Refusé');
                data = data.replace('DESISTED', 'Désistement confirmé');
                data = data.replace('AWAITING', 'Liste complémentaire');
                data = data.replace('CONFIRME', 'Venue confirmée');
                data = data.replace('NOTCONFO', 'Non conforme');
                data = data.replace('CONFORME', 'Conforme');
                data = data.replace(/;/g, '/'); // Replace All ;
            }
            return data;
        }
        return '';
    }

    public static download(blob, filename) {
        if (this.getFileExtension(filename) == null) {
            if (blob.type === 'application/pdf') {
                filename += '.pdf';
            } else if (blob.type === 'image/jpeg') {
                filename += '.jpeg';
            } else if (blob.type === 'application/msword') {
                filename += '.docx';
            } else if (blob.type === 'image/png') {
                filename += '.png';
            }
        }
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename); // For IE
        } else {
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none;');
            let url = URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.target = '_blank';
            a.click();
            URL.revokeObjectURL(url);
        }
    }

    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param selectedColumns
     * @param filename
     */
    toCSV(table: any[], selectedColumns: string[], filename?: string) {
        this.toCSVAvecNomOrigineField(table, selectedColumns, null, null, filename);
    }

    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param nomOrigineFieldList
     * @param selectedColumns
     * @param colHeaderDictionary
     * @param filename
     */
    toCSVAvecNomOrigineField(table: any[], selectedColumns: string[], nomOrigineFieldList: IKeyedCollection<String>,
                             colHeaderDictionary: IKeyedCollection<String>, filename?: string) {

        let formatColumns: IKeyedCollection<(dataValue: any) => String> = new KeyedCollection<(dataValue: any) => String>();
        if (selectedColumns != null) {
            selectedColumns.forEach(column => {
                let nomOrigineField: String = column;
                if (nomOrigineFieldList != null && nomOrigineFieldList.ContainsKey(column)) {
                    nomOrigineField = nomOrigineFieldList.Item(column);
                }
                let format = this.rechercheFormatageDonnee(nomOrigineField);
                formatColumns.Add(nomOrigineField, format);
            });
        }
        this.toFormatedCSV(table, selectedColumns, formatColumns, nomOrigineFieldList, colHeaderDictionary, filename);
    }


    public rechercheFormatageDonnee(nomOrigineField: String): (dataValue: any) => String {
        let format: (dataValue: any) => String;
        if (nomOrigineField.startsWith(ExportService.QUESTION_PREFIX)) {
            format = ExportService.formatQuestionsComplementairesParColonne;
        } else {
            switch (nomOrigineField.toUpperCase()) {
                case 'STATUT':
                    format = ExportService.formatStatut;
                    break;
                case 'FC':
                    format = ExportService.formatFC;
                    break;
                case 'EI':
                    format = ExportService.formatEI;
                    break;
                case 'CAMPAGNES':
                    format = this.formatCampagnes;
                    break;
                case 'DEMANDEMODIFS':
                    format = this.formatDemandeModification;
                    break;
                case 'RANG':
                    format = ExportService.formatRang;
                    break;
                case 'RANGAUTO':
                    format = ExportService.formatRangAuto;
                    break;
                case 'QUESTIONSCOMPLEMENTAIRES':
                    format = ExportService.formatQuestionsComplementaires;
                    break;
                case 'RESPOFORMA':
                    format = ExportService.formatRespoForma;
                    break;
                case 'LECTEURS':
                    format = ExportService.formatLecteurs;
                    break;
                default:
                    format = ExportService.formatData;
                    break;
            }
        }
        return format;
    }

    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param selectedColumns
     * @param formatColumns
     * @param nomOrigineFieldList
     * @param colHeaderDictionary
     * @param filename
     */
    toFormatedCSV(table: any[], selectedColumns: string[],
                  formatColumns: IKeyedCollection<(dataValue: any, record: any) => void>,
                  nomOrigineFieldList: IKeyedCollection<String>,
                  colHeaderDictionary: IKeyedCollection<String>, filename?: string) {
        let csv = '';
        // headers
        for (let i = 0; i < selectedColumns.length; i++) {
            if (selectedColumns[i]) {
                let colName: String = selectedColumns[i];
                if (colHeaderDictionary != null) {
                    if (colHeaderDictionary.ContainsKey(colName)) {
                        colName = colHeaderDictionary.Item(colName);
                    }
                }
                csv += '"' + colName.replace(/<\/?[^>]+(>|$)/g, '').replace(
                    ExportService.QUESTION_PREFIX, '').replace(/"/g, '""') + '"';
                if (i < (selectedColumns.length - 1)) {
                    csv += ';';
                }
            }
        }

        // body
        table.forEach((record) => {
            csv += '\n';
            for (let i = 0; i < selectedColumns.length; i++) {
                let nomOrigineField: string = selectedColumns[i].toString();
                if (nomOrigineFieldList != null && nomOrigineFieldList.ContainsKey(nomOrigineField)) {
                    nomOrigineField = nomOrigineFieldList.Item(nomOrigineField).toString();
                }
                if (nomOrigineField != null && nomOrigineField.length > 0) {

                    let splitedNom: string[] = nomOrigineField.split('.');
                    if (splitedNom.length == 1 || nomOrigineField.startsWith(ExportService.QUESTION_PREFIX)) {
                        let format = formatColumns.Item(nomOrigineField);
                        if (format != null) {
                            csv += '"' + format(record[nomOrigineField], record) + '"';
                        } else {
                            csv += '"' + record[nomOrigineField] + '"';
                        }
                        if (i < (selectedColumns.length - 1)) {
                            csv += ';';
                        }
                    } else {
                        // resolveFieldData seems to check if field is nested e.g. data.something --> probably not needed
                        let format = formatColumns.Item(nomOrigineField);
                        if (record[splitedNom[0]] != null) {
                            if (format != null) {
                                csv += '"' + format(record[splitedNom[0]][splitedNom[1]], record) + '"';
                            } else {
                                csv += '"' + record[splitedNom[0]][splitedNom[1]] + '"';
                            }
                        }
                        if (i < (selectedColumns.length - 1)) {
                            csv += ';';
                        }
                    }
                }
            }
        });
        // Blob is important for UTF-8 encoding !!
        let blob = new Blob(['\ufeff', csv]);
        ExportService.download(blob, filename);
    }

    private formatCampagnes(campagnes?: any, record?: any): string {
        let campagneString = '';
        if (campagnes != null) {
            campagnes.forEach(campagne => {
                if (campagne.display !== undefined && campagne.display === true) {
                    campagneString.length === 0 ? campagneString += campagne.libelle : campagneString += '\n' + campagne.libelle;
                }
            });
        }
        return campagneString;
    }

    private formatDemandeModification(demandeModifs?: any, record?: any): string {
        let demandeString = '';
        if (demandeModifs != null) {
            demandeModifs.forEach(demande => {
                if (demande != null) {
                    demandeString.length === 0 ? demandeString += demande.titre : demandeString += '\n' + demande.titre;
                }
            });
        }
        return demandeString;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/export/export.service.ts